import axios from 'axios';

// Dedicated axios instance for IPP endpoints. Same auth token / cookie as the
// rest of the platform (single sign-on across all apps).
const ippApi = axios.create({ baseURL: '/api/ipp', withCredentials: true });

ippApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('flowup_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

ippApi.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response?.status === 401) {
      const onLogin = window.location.pathname === '/login';
      if (!onLogin) {
        localStorage.removeItem('flowup_token');
        window.dispatchEvent(new CustomEvent('auth:logout'));
        setTimeout(() => { window.location.replace('/login'); }, 100);
      }
    }
    return Promise.reject(err.response?.data || { error: err.message });
  }
);

ippApi.get = (url, config) => ippApi({ method: 'get', url, ...config });
ippApi.post = (url, data, config) => ippApi({ method: 'post', url, data, ...config });
ippApi.put = (url, data, config) => ippApi({ method: 'put', url, data, ...config });
ippApi.delete = (url, config) => ippApi({ method: 'delete', url, ...config });

export default ippApi;

// Final performance ranking options (from the IPP document).
export const RANKINGS = ['Outstanding', 'Excellent', 'Achieved', 'Almost achieved', 'Unsatisfactory'];

export const PLAN_STATUS = {
  draft:     { label: 'Draft',     color: '#8A93A6', bg: 'rgba(138,147,166,0.12)' },
  submitted: { label: 'Submitted', color: '#D97706', bg: 'rgba(217,119,6,0.12)' },
  approved:  { label: 'Fully Approved',  color: '#16A34A', bg: 'rgba(22,163,74,0.12)' },
};

export const fmtDMY = (d) => {
  if (!d) return '—';
  const s = String(d).slice(0, 10);
  const [y, m, day] = s.split('-');
  return (day && m && y) ? `${day}/${m}/${y}` : s;
};
